import request from '@/utils/request'

// 获取客服二维码
export function getCustomerQrcode() {
  return request({
    url: '/api/home/getCustomerQrcode',
    method: 'get'
  })
}

// 获取随机名言
export function getRandomQuote() {
  return request({
    url: '/api/quote/random',
    method: 'get'
  })
}

// 获取管理团队
export function getTeamList() {
  return request({
    url: '/api/index/team',
    method: 'get'
  })
}

// 获取首页统计数据
export function getIndexStatistic() {
  return request({
    url: '/api/index/statistic',
    method: 'get'
  })
}

/**
 * 政策/协议说明
 * @param {{ type: number }} params type: 1注册说明 2提现说明 3用户注册协议 4平台协议 5使用协议 6合约条款 7隐私政策 8Cookie政策
 */
export function getChongzhiPolicy(params) {
  return request({
    url: '/api/index/chongzhi',
    method: 'get',
    params
  })
}
